import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { useSignOffIdentity } from './useSignOffIdentity';

function CaseChecklistSummary() {
    const { name, date } = useSignOffIdentity();

    return (
        <div className="flex items-center gap-1.5 text-sm text-gray-600">
            <CheckCircleIcon className="w-4 h-4 flex-shrink-0 text-emerald-500" />
            <span>
                Signed off by <span className="font-medium text-gray-800">{name}</span> · {date}
            </span>
        </div>
    );
}

export { CaseChecklistSummary };
